import { Plug } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PlugIcon = createLucideIcon(Plug);
